module.exports = __webpack_public_path__ + "img/plant-health-surveillance.2b04a496.jpg";